import type { PayloadAction } from '@reduxjs/toolkit';

import { SET_USER, User } from './types';

const initialState: User | null = null;

export function userReducer(state = initialState, action: PayloadAction<User | null>): User | null {
	switch (action.type) {
		case SET_USER: {
			return action.payload;
		}
		default:
			return state;
	}
}
